module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/landing-page-headshot/landing-page-headshot@3x.png"